import { FC } from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { Box, Link } from "@material-ui/core";
import useStyles from "../Styles/PopOverStyles";
import { PopoverProps } from "../../interfaces";
import Uniswap from "../../assets/images/UniSwapIcon.svg";
import PancakeSwap from "../../assets/images/PanCakeSwapIcon.svg";
import Ondefy from "../../assets/images/Ondefy.svg";
import BridgeToken from "../../assets/images/bridgeToken.svg";
import Mexc from "../../assets/images/mexc_logo.svg";

const BuyGainsMenu: FC<PopoverProps> = ({
  id,
  open,
  anchorEl,
  handleClose,
}) => {
  const classes = useStyles();

  return (
    <Popover
      className={classes.buyMenu}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      disableScrollLock={false}  // Prevents body scroll when the menu is open
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Box m={"0.5rem"} style={{ width: "216px" }}>
        <Box>
          <Box className={classes.listRowHover}>
            <Link
              href="https://pancakeswap.finance/swap?outputCurrency=0xf1C3e69494E27bf067C4076a6f244a46446719d6"
              target="_blank"
              rel="noreferrer"
              className={classes.listRow}
            >
              <Typography variant="body1" color="secondary" className={classes.listTitle}>
                Buy On Pancakeswap
              </Typography>
              <img src={PancakeSwap} alt="buy gains on pancakeswap" />
            </Link>
          </Box>
          <Box
            m={"0.5rem 0"}
            className={classes.smallProfileDivider}
            style={{ width: "calc(100% + 1rem)", marginLeft: "-0.5rem" }}
          />
          <Box className={classes.listRowHover}>
            <Link
              href="https://app.uniswap.org/swap?outputCurrency=0x056C1D42Fb1326f57da7f19eBB7dDA4673f1FF55"
              target="_blank"
              rel="noreferrer"
              className={classes.listRow}
            >
              <Typography variant="body1" color="secondary" className={classes.listTitle}>
                Buy On Uniswap
              </Typography>
              <img src={Uniswap} alt="buy gains on uniswap" />
            </Link>
          </Box>
          <Box
            m={"0.5rem 0"}
            className={classes.smallProfileDivider}
            style={{ width: "calc(100% + 1rem)", marginLeft: "-0.5rem" }}
          />
          <Box className={classes.listRowHover}>
            <Link
              href="https://www.mexc.com/exchange/GAINS_USDT?_from=market"
              target="_blank"
              rel="noreferrer"
              className={classes.listRow}
            >
              <Typography variant="body1" color="secondary" className={classes.listTitle}>
                Buy On MEXC
              </Typography>
              <img src={Mexc} width="28px" alt="buy gains on Mexc" />
            </Link>
          </Box>
          <Box
            m={"0.5rem 0"}
            className={classes.smallProfileDivider}
            style={{ width: "calc(100% + 1rem)", marginLeft: "-0.5rem" }}
          />
          <Box className={classes.listRowHover}>
            <Link
              href="https://ramp.ondefy.com/?tokenId=gains"
              target="_blank"
              rel="noreferrer"
              className={classes.listRow}
            >
              <Typography variant="body1" color="secondary" className={classes.listTitle}>
                Buy With Fiat
              </Typography>
              <img width="25px" src={Ondefy} alt="buy gains with fiat" />
            </Link>
          </Box>
          <Box
            m={"0.5rem 0"}
            className={classes.profileDivider}
            style={{ width: "calc(100% + 1rem)", marginLeft: "-0.5rem" }}
          />
          <Box className={classes.listRowHover}>
            <Link
              href="http://gainsassociates.medium.com/how-to-bridge-gains-from-ethereum-to-bnb-chain-with-chainport-340e8f0e40a"
              target="_blank"
              rel="noreferrer"
              className={classes.listRow}
            >
              <Typography variant="body1" color="secondary" className={classes.listTitle}>
                Bridge Token
              </Typography>
              <img src={BridgeToken} alt="GAINS bridge token" />
            </Link>
          </Box>
        </Box>
      </Box>
    </Popover>
  );
};

export default BuyGainsMenu;
